export default "__VITE_ASSET__DIsFsW$L__"